var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M20 7.42a7 7 0 01-1.885.477c.678-.374 1.199-.968 1.443-1.675a6.885 6.885 0 01-2.086.734A3.407 3.407 0 0015.077 6c-1.812 0-3.282 1.356-3.282 3.03 0 .237.028.468.085.689-2.728-.127-5.146-1.331-6.767-3.165a2.845 2.845 0 00-.443 1.524c0 1.05.58 1.977 1.46 2.521a3.502 3.502 0 01-1.488-.378v.037c0 1.469 1.132 2.693 2.634 2.97a3.451 3.451 0 01-.865.107 3.48 3.48 0 01-.617-.054c.418 1.204 1.629 2.08 3.066 2.103a6.944 6.944 0 01-4.077 1.297c-.265 0-.527-.013-.783-.041A9.869 9.869 0 009.031 18c6.04 0 9.34-4.615 9.34-8.619a8.2 8.2 0 00-.009-.392A6.384 6.384 0 0020 7.42z",
    clipRule: "evenodd"
  }));
}
export default SvgIconTwitter;